var catValue = "all";
var teamTermValue = "all";
if (window.history && window.history.pushState) {
    jQuery(window).on('pageshow', function () {
        // jQuery("body").css("display", "none");
        if (jQuery("body").is(":hidden")) {
            jQuery("body").fadeIn(800);
        }
    });
    jQuery(window).on('popstate', function () {
        // jQuery("body").css("display", "none");
        if (jQuery("body").is(":hidden")) {
            jQuery("body").fadeIn(800);
        }
    });
}
jQuery(document).ready(function ($) {

    $('body').on('click', 'nav .modal-menu button.sub-menu-toggle', function () {
        $(this).parent().parent().siblings().find('button.sub-menu-toggle').removeClass("active");
        $(this).parent().parent().siblings().find('button.sub-menu-toggle').parent().next().slideUp().parent().removeClass('open');
        $(this).toggleClass('active').parent().next().slideToggle().parent().toggleClass('open');
    });

    $("body").css("display", "none");
    $("body").fadeIn(800);
    // to fade out before redirect
    $('.menu-item:not(.confirmation_check, .custom_attribute, .menu_lets_talk_popup) > a').click(function (e) {
        redirect = $(this).attr('href');
        e.preventDefault();
        $('body').fadeOut(800, function () {
            document.location.href = redirect
        });
    });

    jQuery(".primary-menu .menu-item").each(function () {
        var link_text = jQuery(this).find(">a").text();
        jQuery(this).find(">a").attr("data-title", link_text);
    })

    $(".image__data").each(function (index) {
        let slide = $(this).find('.image__data__slider__item');
        let slider = $(this).find('.image__data__slider');
        let dots = $(this).find('.image__data__dots__inner');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                dots: true,
                speed: 1000,
                fade: true,
                appendDots: $(dots),
                autoplay: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
            });
        }
    });


    if (jQuery(".hero_banner_list_slider").length > 0) {
        jQuery(".hero_banner_list_slider").slick({
            arrows: false,
            dots: true,
            infinite: false,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            adaptiveHeight: true,
        })
    }

    jQuery(".hero_banner_list_slider ul.slick-dots").each(function (index) {
        if (jQuery(this).find('li').length == 1) {
            jQuery(this).remove();
        }
    });

    if ($('.team_slider_section .team_slider_list').length > 0) {
        $('.team_slider_section .team_slider_list').on('init', function (slick) {
            var dotLi = $('.team_slider_section .slick-dots > li')
            var dot = dotLi.length;
            dotLi.css('width', (100 / dot) + '%');
        });

        jQuery(".team_slider_section .team_slider_list").slick({
            dots: true,
            infinite: false,
            arrows: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            customPaging: function (slider, i) {
                // console.info(i);
                return '<span class="dot_text">' + jQuery(".team_slider_list .team_slider_item[data-slick-index='" + i + "']").attr("data-name") + '</span>';
            },
        });

        $(".team_slider_section .slick-dots").wrap("<div class='team_dots_scroll'></div>");
    }

    if (jQuery(".post_list_with_filter").length > 0) {
        jQuery(".post_list_with_filter .posts_cat_list .cat_link").on("click", function () {
            jQuery(".post_list_with_filter .posts_cat_list .cat_link").removeClass("active");
            jQuery(this).addClass("active");
            catValue = jQuery(this).attr("data-item");
            paged = 1;
            jQuery(".post_list_with_filter .paged").val(paged)
            filterPost("filter");
        })
        jQuery(".category_selection #category_dropdown").on("change", function () {
            // jQuery(".post_list_with_filter .posts_cat_list .cat_link").removeClass("active");
            // jQuery(this).addClass("active");
            paged = 1;
            jQuery(".post_list_with_filter .paged").val(paged)
            catValue = jQuery(this).val();
            filterPost("filter");
        })
        jQuery(".post_list_with_filter .load_more_btn").on("click", function () {
            filterPost("loadmore");
        })
    }

    if (jQuery(".team_list_with_filter").length > 0) {
        teamTermValue = jQuery(".team_list_with_filter .posts_cat_list .cat_item.active .cat_link").attr("data-item");
        jQuery(".team_list_with_filter .posts_cat_list .cat_link").on("click", function () {

            $(this).parent().siblings().removeClass('active');
            $(this).parent().addClass('active');

            teamTermValue = jQuery(this).attr("data-item");
            filterTeam("filter");
        })
        jQuery(".team_list_with_filter .load_more_btn").on("click", function () {
            // var count1 = jQuery(this).attr("data-count");
            // var current1 = jQuery(this).attr("data-current");
            // current1 = parseInt(current1);
            // count1 = parseInt(count1);
            // if (count1 >= current1) {
            //     current1 = current1 + 1;
            //     jQuery(this).attr("data-current", current1);
            //     setTimeout(function () {
            //         jQuery(".team_list_with_filter .post_list .team_item.block-" + current1).show();
            //     }, 1000);
            //     if (current1 == count1) {
            //         jQuery(this).parent().hide();
            //     }
            // }
            filterTeam("loadmore");
        })
    }

    $('.tabbing_section .tabs .tab-link').click(function () {
        var tab_id = $(this).attr('data-tab');

        $('.tabbing_section .tabs .tab-link').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
        var asofdate = jQuery(".tabbing_section .content_part .tab-content.current .as_of_date").attr("data-date");
        jQuery(".flyout_panel_content#performance .table_section .section_inner.table_1 .column_heading .column_1").html(asofdate);
    })

    $(".hero_banner_list_outer .hero_banner_item .link_list .link, .left_right_image_content_list_section .title_text_link_section .link_section .btn, .content_with_bg .content_with_bg_wrapper a").on("click", function (e) {
        var hrefLink = $(this).attr("href");
        // if (hrefLink.indexOf("flyout_panel") > -1) {
        var hrefLinkArr = hrefLink.split("#");
        if (hrefLinkArr.length > 1) {
            if (jQuery(".tabbing_section .content_part .flyout_panel .item a.heading[href='#" + hrefLinkArr[1] + "']").length > 0) {
                e.preventDefault();
                jQuery(".tabbing_section .content_part .flyout_panel .item a.heading[href='#" + hrefLinkArr[1] + "']").click();
            }
        }
        // }
    })

    $(".tabbing_section .section_inner .content_part .tab_content_inner .notes .note_text a").on("click", function (e) {
        var hrefLink = $(this).attr("href");
        // if (hrefLink.indexOf("flyout_panel") > -1) {
        var hrefLinkArr = hrefLink.split("#");
        if (hrefLinkArr.length > 1) {
            if (jQuery(".tabbing_section .content_part .flyout_panel .item a.heading[href='#" + hrefLinkArr[1] + "']").length > 0) {
                e.preventDefault();
                jQuery(".tabbing_section .content_part .flyout_panel .item a.heading[href='#" + hrefLinkArr[1] + "']").click();
            }
        }
        // }
    })

    $(".tabbing_section .flyout_panel a.heading").on("click", function (event) {
        event.preventDefault();

        /* if( $(this).hasClass('active') == true ){
            return false;
        } */
        // $('.tabbing_section .flyout_panel a.heading').removeClass('active');        
        $(this).addClass('active');
        var divId = $(this).attr('href');
        $('.tabbing_section').addClass("show_overlay left");
        setTimeout(function () {
            $('.flyout_panel_content' + divId).addClass('open');
            $('body').addClass('open_flyout_panel');
        }, 300)

    });

    $(".flyout_panel_content a.close_icon").on("click", function (event) {
        event.preventDefault();
        $('.tabbing_section .flyout_panel a.heading.active').removeClass('active');
        $('.flyout_panel_content.open').removeClass('open');
        $('body.open_flyout_panel').removeClass('open_flyout_panel');
        setTimeout(function () {
            $('.tabbing_section').removeClass("left");
            setTimeout(function () {
                $('.tabbing_section').removeClass("show_overlay");
            }, 300);
        }, 300);
    });

    $(".tabs_with_pdf_viewer .tabs_list_heading .tab_heading_item").on("click", function () {
        var tab_id = $(this).attr("data-tab");
        $(".tabs_with_pdf_viewer .tabs_list_heading .tab_heading_item").removeClass("active");
        $(this).addClass("active");
        $(".tabs_with_pdf_viewer .tabs_list_content .tab_content_item").removeClass("active");
        $(".tabs_with_pdf_viewer .tabs_list_content .tab_content_item" + tab_id).addClass("active");
    })

    if ($('.post_content iframe').length > 0) {
        $('.post_content iframe').parent().addClass('embed-container');
    }

    jQuery(document).on("click", function (e) {
        if (jQuery(".flyout_panel_content").hasClass("open")) {
            if (jQuery(e.target).closest(".content_section").length === 0 && jQuery(e.target).closest(".close_section").length === 0) {
                jQuery(".flyout_panel_content.open").removeClass("open");
                jQuery("body").removeClass("open_flyout_panel");
                jQuery(".tabbing_section").removeClass("show_overlay")
            }
        }
    })

    jQuery(".globalDropdown, .selectric_dropdown").selectric({
        disableOnMobile: false,
        nativeOnMobile: false
    })

    var totalHeight = jQuery("#site-header").outerHeight();
    jQuery("#site-content").css({
        "padding-top": totalHeight + "px"
    });

    var onclickVal = "(function(){ var _hsp = window._hsp = window._hsp || []; _hsp.push(['showBanner']); })()";
    jQuery(".menu-item.custom_attribute a").attr("onclick", onclickVal);
    jQuery(".menu-item.custom_attribute a").attr("href", "javascript:void(0)");

    jQuery("#site-footer .address_section_item .address_heading").on("click", function () {
        if (jQuery(this).parent().find(".address_content").is(":hidden")) {
            jQuery(this).parent().find(".address_content").slideDown();
            jQuery(this).addClass("active");
        } else {
            jQuery(this).parent().find(".address_content").slideUp();
            jQuery(this).removeClass("active");
        }
    })

    jQuery(".read_more_link_div .read_more_link").on("click", function () {
        if (jQuery(window).width() > 991) {
            if (jQuery(this).hasClass("readmore")) {
                jQuery(".list_links_item.second_row").addClass("active");
                jQuery(this).text("Read Less");
                jQuery(this).removeClass("readmore");
            } else {
                jQuery(".list_links_item.second_row").removeClass("active");
                jQuery(this).text("Read More");
                jQuery(this).addClass("readmore");
            }
        } else {
            if (jQuery(this).hasClass("readmore")) {
                jQuery(".list_links_item.second_row").slideDown();
                jQuery(this).text("Read Less");
                jQuery(this).removeClass("readmore");
            } else {
                jQuery(".list_links_item.second_row").slideUp();
                jQuery(this).text("Read More");
                jQuery(this).addClass("readmore");
            }
        }
    })

    jQuery(".standard_editor .read_more_content_section .btn").on("click", function () {
        if (jQuery(this).parent().find(".read_more_content").is(":hidden")) {
            jQuery(this).parent().find(".read_more_content").slideDown();
            jQuery(this).removeClass("readmore").addClass("readless");
            jQuery(this).text("Read Less");
        } else {
            jQuery(this).parent().find(".read_more_content").slideUp();
            jQuery(this).addClass("readmore").removeClass("readless");
            jQuery(this).text("Read More");
        }
    })

    jQuery(".left_content_right_image_section .read_more_content_section .btn").on("click", function () {
        if (jQuery(this).parent().find(".read_more_content").is(":hidden")) {
            jQuery(this).parent().find(".read_more_content").slideDown();
            jQuery(this).removeClass("readmore").addClass("readless");
            jQuery(this).text("Read Less");
            jQuery(this).fadeOut();
        }
    })
})

function filterPost(type) {
    var perpage = jQuery(".post_list_with_filter .page_items").val();
    var paged = jQuery(".post_list_with_filter .paged").val();
    var ajax_call_url = jQuery(".post_list_with_filter .url").val();
    var feature_post = jQuery(".post_list_with_filter .feature_post").val();
    var currentPostCount = jQuery(".post_list_with_filter .post_list > div").length;
    // var cat = jQuery(".post_list_with_filter .post_filter .cat_link.active").attr("data-item");
    if (paged != "") {
        paged = parseInt(paged);
    } else {
        paged = 1;
    }
    if (type == "loadmore") {
        paged = paged + 1;
        jQuery(".post_list_with_filter .paged").val(paged)
    } else {
        jQuery(".post_list_with_filter .paged").val(1)
    }

    jsonObj = {
        "action": "filter_data",
        "category": catValue,
        "postperpage": parseInt(perpage),
        "currentPostCount": currentPostCount,
        "type": type,
        "paged": paged
    };

    if (feature_post != "") {
        jsonObj['feature_post'] = feature_post;
    }

    jQuery.ajax({
        url: ajax_call_url,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            // console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                jQuery('.load_more_img').hide();
                jQuery(".post_list_with_filter .post_list").html("<div class='no_found'>Result not found!!</div>");
                jQuery(".post_list_with_filter .post_list").show();
                jQuery(".load_more_button").hide();
                return false;
            } else if (type == 'loadmore') {
                jQuery('.load_more_img').hide();
                jQuery(".post_list_with_filter .post_list").show();
                jQuery(".post_list_with_filter .post_list").append(data.data);
            } else {
                jQuery(".post_list_with_filter .post_list").html("");
                jQuery(".post_list_with_filter .post_list").html(data.data);
                jQuery('.load_more_img').hide();
                jQuery(".post_list_with_filter .post_list").show();
            }

            setTimeout(function () {
                var total = jQuery("#total_post_count").val();
                var current = jQuery("#current_post_count").val();

                var c_total = jQuery(".post_list_with_filter .post_list > div").length;
                if (total != '' && current != '') {
                    if (parseInt(total) == c_total) {
                        jQuery(".load_more_button").hide();
                    } else {
                        jQuery(".load_more_button").show();
                    }
                }
                jQuery("#total_post_count").remove();
                jQuery("#current_post_count").remove();
            }, 1000);

        },
        error: function (xhr) {
            jQuery('.load_more_img').hide();
            jQuery(".post_list_with_filter .post_list").show();
            console.log(xhr);
        }
    });
}

function filterTeam(type) {
    var perpage = jQuery(".team_list_with_filter .page_items").val();
    var paged = jQuery(".team_list_with_filter .paged").val();
    var ajax_call_url = jQuery(".team_list_with_filter .url").val();
    var orderby = jQuery(".team_list_with_filter .orderby").val();
    var currentPostCount = jQuery(".team_list_with_filter .post_list > div").length;

    if (paged != "") {
        paged = parseInt(paged);
    } else {
        paged = 1;
    }
    if (type == "loadmore") {
        paged = paged + 1;
        jQuery(".team_list_with_filter .paged").val(paged)
    } else {
        jQuery(".team_list_with_filter .paged").val(1)
    }
    var ids = [];
    jQuery(".team_list_with_filter .post_list .team_item").each(function () {
        var i1 = jQuery(this).attr("data-id");
        if (i1 != undefined && i1 != "" && i1 != null) {
            ids.push(i1);
        }
    })
    jsonObj = {
        "action": "filter_team",
        "category": teamTermValue,
        "postperpage": parseInt(perpage),
        "currentPostCount": currentPostCount,
        "type": type,
        "paged": paged,
        "orderby": orderby,
        "existingIds": ids
    };

    jQuery.ajax({
        url: ajax_call_url,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            // console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                jQuery('.load_more_img').hide();
                jQuery(".team_list_with_filter .post_list").html("<div class='no_found'>Result not found!!</div>");
                jQuery(".team_list_with_filter .post_list").show();
                jQuery(".load_more_button").hide();
                return false;
            } else if (type == 'loadmore') {
                jQuery('.load_more_img').hide();
                jQuery(".team_list_with_filter .post_list").show();
                jQuery(".team_list_with_filter .post_list").append(data.data);
            } else {
                jQuery(".team_list_with_filter .post_list").html("");
                jQuery(".team_list_with_filter .post_list").html(data.data);
                jQuery('.load_more_img').hide();
                jQuery(".team_list_with_filter .post_list").show();
            }

            setTimeout(function () {
                var total = jQuery("#total_post_count").val();
                var current = jQuery("#current_post_count").val();

                var c_total = jQuery(".team_list_with_filter .post_list > div").length;
                if (total != '' && current != '') {
                    if (parseInt(total) == c_total) {
                        jQuery(".load_more_button").hide();
                    } else {
                        jQuery(".load_more_button").show();
                    }
                }
                jQuery("#total_post_count").remove();
                jQuery("#current_post_count").remove();
            }, 1000);

        },
        error: function (xhr) {
            jQuery('.load_more_img').hide();
            jQuery(".team_list_with_filter .post_list").show();
            console.log(xhr);
        }
    });
}

jQuery(window).on("scroll", function ($) {
    if (jQuery('.numbers_list_section .number:not(.applied)').length > 0) {
        var numbers_section = jQuery('.number').offset().top - window.innerHeight;
        if (numbers_section < jQuery(window).scrollTop()) {
            startnumbers();
        }
    }

});

function startnumbers() {
    jQuery('.numbers_list_section .number').addClass("applied");
    jQuery('.number .count').each(function () {
        var $this = jQuery(this),
            countTo = $this.attr('data-count');

        jQuery({
            countNum: $this.text()
        }).animate({
            countNum: countTo
        }, {
            duration: 1000,
            easing: 'linear',
            step: function () {
                $this.text(Math.ceil(this.countNum).toLocaleString('en'));
            },
            complete: function () {
                $this.text(this.countNum.toLocaleString('en'));
            }
        });
    });
}



var prevScrollpos = jQuery('#site-header').height();
window.onscroll = function () {
    var currentScrollPos = window.pageYOffset,
        siteheader = document.getElementById("site-header"),
        siteheaderHeigjt = siteheader.offsetHeight * 2;
    if (prevScrollpos > currentScrollPos) {
        if (jQuery(".admin-bar").length > 0) {
            if (jQuery(window).width() < 783) {
                siteheader.style.top = "46px";
            } else {
                siteheader.style.top = "32px";
            }
        } else {
            siteheader.style.top = "0";
        }
    } else {
        if (siteheaderHeigjt < currentScrollPos) {
            siteheader.style.top = "-" + siteheaderHeigjt + "px";
        }
    }
    prevScrollpos = currentScrollPos;
}

/* jQuery(window).on("resize", function () {
    var totalHeight = jQuery("#site-header").outerHeight();
    jQuery("#site-content").css({
        "padding-top": totalHeight + "px"
    });
    // if (jQuery(window).width() < 992) {
    //     jQuery(".read_more_link_div .read_more_link").addClass("readmore");
    // }

}) */